import React, { useState } from "react";
import { Box, IconButton, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VehiclesModel, { vehiclesToProductDetail } from "../../../../../models/vehicles.model";
import { treatString } from "../../../../../utils";
import { ProductDetailDrawer } from "../products/product-detail-drawer";

type Props = {
    observation?: string;
    vehicles: VehiclesModel;
    onObservationChange: (observation: string) => void;
};

export const VehiclesItem: React.FC<Props> = ({ vehicles, observation, onObservationChange }) => {
    const theme = useTheme();
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Box
            sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: "13px",
                backgroundColor: "background.paper",
                p: "14px 16px",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontSize: "14.5px", fontWeight: 600, color: "text.primary" }}>
                        {treatString(vehicles.name.toLowerCase(), 40, { capitalize: true })}
                    </Typography>
                    <Typography sx={{ fontSize: "12.5px", color: "text.secondary", mt: "2px", lineHeight: 1.35 }}>
                        {treatString(vehicles.description.toLowerCase(), 80, { capitalize: true })}
                    </Typography>
                </Box>
                <Tooltip title="Informações" placement="top">
                    <IconButton size="small" onClick={() => setModalOpen(true)} sx={{ color: "primary.main", flexShrink: 0 }}>
                        <VisibilityIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
            </Box>

            <TextField
                placeholder="Observação do veículo"
                variant="outlined"
                fullWidth
                size="small"
                value={observation}
                onChange={(event) => onObservationChange(event.target.value)}
                sx={{ mt: 1.5 }}
            />

            <ProductDetailDrawer
                open={modalOpen}
                detail={vehiclesToProductDetail(vehicles)}
                onClose={() => setModalOpen(false)}
                typeLabel="Veículo"
            />
        </Box>
    );
};
